import * as React from 'react'
import type { ComponentProps } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import Text from 'modules/core/components/Inputs/Text'
import TogglerCheckbox from 'modules/core/components/Inputs/TogglerCheckbox'
import i18n from 'modules/core/lib/i18n'

import type ArgumentForm from 'modules/reports/components/Editor/Field/Options/Types/Filtering/ArgumentForm'
import { VARIABLE_TYPES } from 'modules/reports/store/models/Dashboard'

type TextRowProps = {
  label: string
  form: ArgumentForm
  variableOptions: ComponentProps<typeof Select>['options']
}

interface Props {
  forms: ArgumentForm[]
  variables: Array<{
    name: string
    type: string
  }>
}

const TextRow = observer(({ label, form, variableOptions }: TextRowProps) => {
  const useVariable = !!form.get('use_variable').value

  return (
    <Box
      flexDirection="column"
      gap="s8"
      background="grey200"
      padding="s24"
      borderRadius={{
        all: 'abs008',
      }}
    >
      <FormRow>
        {useVariable && (
          <Select
            none={i18n.t('custom_reports.fields.filter_condition_none')}
            label={label}
            field={form.get('value')}
            options={variableOptions}
          />
        )}
        {!useVariable && <Text label={label} field={form.get('value')} />}
      </FormRow>
      {!!variableOptions.length && (
        <TogglerCheckbox
          label={i18n.t('custom_reports.use_dashboard_filters')}
          field={form.get('use_variable')}
        />
      )}
    </Box>
  )
})

const GenericText = ({ forms, variables }: Props) => {
  const oneArgLabel = i18n.t('custom_reports.filter_arguments_labels.value')

  const variableOptions = variables
    .filter((variable) => variable.type === VARIABLE_TYPES.text)
    .map((variable) => ({
      label: variable.name,
      value: variable.name,
    }))

  return (
    <>
      {forms.map((form: ArgumentForm, index: number) => {
        const argLabelX = i18n.t('custom_reports.filter_arguments_labels.value_x', {
          count: index + 1,
        })

        const label = forms.length === 1 ? oneArgLabel : argLabelX

        return <TextRow key={index} label={label} form={form} variableOptions={variableOptions} />
      })}
    </>
  )
}

export default observer(GenericText)
